import SlimNotificationContainer from './SlimNotificationContainer';
export default SlimNotificationContainer;
